import {computed, reactive, ref} from "vue";
import {snakeToCamelCase} from "../../../frontend/src/helpers/string";

export default function (form) {
    const defaultValues = ref(JSON.stringify(form));

    const errors = reactive(Object.keys(form).reduce((acc, key) => {
        acc[key] = [];
        return acc;
    }, {}));

    const formFilled = computed(() => {
        let defaultObject = JSON.parse(defaultValues.value);

        return Object.keys(form).some(key => {
            return JSON.stringify(form[key]) !== JSON.stringify(defaultObject[key]);
        })
    });

    const flatErrors = computed(() => Object.values(errors).flat())

    function hasErrors(data) {
        if (!Object.keys(data.errors).length) {
            clearErrors();

            return false;
        } else {
            setErrors(data.errors);

            return true;
        }
    }

    function setErrors(data) {
        for (const key in data) {
            let snakeCaseKey = snakeToCamelCase(key);
            errors[snakeCaseKey] = data[key];
        }
    }

    function clearErrors() {
        for (const key in errors) {
            errors[key] = [];
        }
    }

    function populateForm(data) {
        Object.keys(data).forEach(key => {
            if (key in form) {
                form[key] = data[key];
            } else {
                let snakeCaseKey = snakeToCamelCase(key);

                if (snakeCaseKey in form) {
                    form[snakeCaseKey] = data[key];
                }
            }
        });
    }

    function resetForm() {
        let defaultObject = JSON.parse(defaultValues.value);

        Object.keys(form).forEach(key => {
            form[key] = defaultObject[key];
        });

        clearErrors();
    }

    function updateDefault() {
        defaultValues.value = JSON.stringify(form);
    }

    return {
        populateForm,
        resetForm,
        errors,
        flatErrors,
        hasErrors,
        setErrors,
        clearErrors,
        formFilled,
        updateDefault
    };
}
